/**
 * dictionary模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const dictionary = {
  // 获取字典
  getDictionarys (params) {
    return axios.get('/api/dictionary/getDictionarys', { params })
  }
}

export default dictionary
